module.exports = __webpack_public_path__ + "static/media/logo.8ed5608b.svg";